import { useEffect } from "react";

const SITE = "https://www.serviceandbusiness.it";

const setMeta = (attr, key, content) => {
    let el = document.head.querySelector(`meta[${attr}="${key}"]`);
    if (!el) {
        el = document.createElement("meta");
        el.setAttribute(attr, key);
        document.head.appendChild(el);
    }
    el.setAttribute("content", content);
};

export const useSEO = (title, description) => {
    useEffect(() => {
        document.title = title;
        if (description) setMeta("name", "description", description);
        setMeta("property", "og:title", title);
        if (description) setMeta("property", "og:description", description);
        const url = `${SITE}${window.location.pathname}`;
        setMeta("property", "og:url", url);
        let canonical = document.head.querySelector('link[rel="canonical"]');
        if (!canonical) {
            canonical = document.createElement("link");
            canonical.setAttribute("rel", "canonical");
            document.head.appendChild(canonical);
        }
        canonical.setAttribute("href", url);
    }, [title, description]);
};

export default useSEO;
